import { Suspense, ComponentProps, } from 'react';
import { Route, withRouter, RouteComponentProps, Switch } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { LoginPool, QysCheck } from '../../lib';


function RouteLogin(props: RouteComponentProps & ComponentProps<any>) {
    const parentPath: string = fomatParentPath(props);
    return (
        <Switch weId={`${props.weId || ''}_sa2zv8`}>
            {/* <Route weId={`${props.weId || ''}_pb8iga`} path={`${parentPath}/passport/qyscheck`} component={QysCheck} /> */}
            <Route weId={`${props.weId || ''}_nkq7on`} path={`${parentPath}/`} component={LoginPool} />
        </Switch>
    )
}

export default withRouter(RouteLogin);
